<div class="header-bar">
  <div class="navbar navbar-custom">
    <a class="navbar-brand logomain mt-2" id="hidetxt"
      ><img
        src="assets/images/logotxt.svg"
        height="33"
        class="logo ml-3 logotextClick" /><img
        src="assets/images/logotxt.svg"
        width="150"
        class="logo1 sectpad logotextClick"
    /></a>
  </div>
  <div class="col-12 text-center webview">
    <!-- <img src="assets/images/eva-icons.svg" class="signimg1 prescsimg" /> -->
  </div>
</div>
<main role="main" class="maincnt">
  <div class="col-12 text-center webview"></div>
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 mrgn mt-5 signupmobilenobg">
        <a _ngcontent-c5="" class="mobclose" href="javascript:void(0);"
          ><img
            _ngcontent-c5=""
            src="assets/images/mobclose.png"
            (click)="closebtn()"
        /></a>
        <h1
          class="text-center headfont loginmrgn signuppadd resethead semi-bold"
        >
          Reset Password
        </h1>
        <div class="container mt-4">
          <div class="row">
            <div class="text-center col-md-7 col-sm-8 col-lg-7 m-auto">
              <form
                name="form"
                (ngSubmit)="f.form.valid && login($event, f)"
                #f="ngForm"
                novalidate
              >
                <div class="text-center col-sm-12 col-md-12 col-lg-8 m-auto">
                  <div class="form-group float-label-control">
                    <label for="email"></label>
                    <input
                      type="hidden"
                      class="form-control inputshadow"
                      name="email"
                      [(ngModel)]="userObj.emailId"
                      #email="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                      required
                      email
                      disabled
                      pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                    />
                  </div>
                  <div
                    class="form-group float-label-control mb-0"
                    style="margin-bottom: 9px !important"
                  >
                    <div class="d-flex flex-row">
                      <div
                        class="col-12 p-0 position-relative"
                        style="width: 90%"
                      >
                        <div class="form-group float-label-control">
                          <label
                            for="password"
                            style="font-size: 1.5em !important"
                            >New Password</label
                          >
                          <input
                            class="form-control inputshadow"
                            name="password"
                            [(ngModel)]="userObj.password"
                            #password="ngModel"
                            type="{{ user_bot ? 'text' : 'password' }}"
                            [ngClass]="{
                              'is-invalid': f.submitted && password.invalid
                            }"
                            required
                            minlength="8"
                            pattern="(?=.*\d)(?=.*[!@#$%.^&*])(?=.*[A-Z]).{8,}"
                          />
                        </div>
                        <div class="invalid-feedback posabs">
                          <div>
                            <div
                              class="boxcolour"
                              *ngIf="
                                f.submitted &&
                                password.invalid &&
                                password.errors &&
                                password.errors.required
                              "
                            >
                              <span
                                _ngcontent-c8=""
                                class="fa fa-exclamation-circle mr-1"
                                type="Icon"
                              ></span>
                              Password is required
                            </div>
                            <div
                              [hidden]="
                                password.valid ||
                                password.pristine ||
                                !password.errors.pattern
                              "
                              class="boxcolour"
                              style="line-height: 80%"
                            >
                              <span
                                _ngcontent-c8=""
                                class="fa fa-exclamation-circle mr-1"
                                type="Icon"
                              ></span>
                              Password should contain at least 8 characters with
                              1 Uppercase, 1 special character and 1 number
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="float-right"
                        style="width: 10%"
                        *ngIf="userObj.password"
                      >
                        <i
                          *ngIf="user_bot"
                          (click)="toggleShowPassword(userObj.password)"
                          id="toggleId"
                          class="fa fa-eye"
                          style="cursor: pointer"
                        ></i>
                        <i
                          *ngIf="!user_bot"
                          (click)="toggleShowPassword(userObj.password)"
                          id="toggleId"
                          class="fa fa-eye-slash"
                          style="cursor: pointer"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-group float-label-control mb-0">
                    <div class="d-flex flex-row">
                      <div
                        class="col-12 p-0 position-relative"
                        style="width: 90%"
                      >
                        <div
                          class="form-group float-label-control"
                          style="margin-bottom: 0px !important"
                        >
                          <label
                            for="password"
                            style="font-size: 1.5em !important"
                            >Confirm New Password</label
                          >
                          <input
                            class="form-control inputshadow"
                            name="confirmPassword"
                            [(ngModel)]="userObj.confirmPassword"
                            #confirmPassword="ngModel"
                            type="{{ user_bot1 ? 'text' : 'password' }}"
                            [ngClass]="{
                              'is-invalid':
                                f.submitted && confirmPassword.invalid
                            }"
                            required
                            minlength="8"
                            pattern="(?=.*\d)(?=.*[!@#$%.^&*])(?=.*[A-Z]).{8,}"
                            (keyup)="onKeyUpconfirm($event)"
                            (blur)="validatePassword()"
                          />
                        </div>
                        <div style="color: red; float: left">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div
                        class="float-right"
                        style="width: 10%"
                        *ngIf="userObj.confirmPassword"
                      >
                        <i
                          *ngIf="user_bot1"
                          (click)="
                            toggleConfirmPassword(userObj.confirmPassword)
                          "
                          id="toggleId"
                          class="fa fa-eye"
                          style="cursor: pointer"
                        ></i>
                        <i
                          *ngIf="!user_bot1"
                          (click)="
                            toggleConfirmPassword(userObj.confirmPassword)
                          "
                          id="toggleId"
                          class="fa fa-eye-slash"
                          style="cursor: pointer"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  class="btn mr-2 ml-2 col-sm-6 mt-4 font22 text-uppercase mx-4"
                  style="
                    width: auto !important;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                  [ngClass]="{
                    sectbtn: f.form.valid,
                    disabledButton: !f.form.valid
                  }"
                  [disabled]="!f.form.valid"
                >
                  SAVE NEW PASSWORD
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<div
  class="modal fade"
  data-backdrop="static"
  data-keyboard="false"
  id="pswdResetModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="service-modal">
          <div class="bdy-sec">
            <div class="text-center mt-4 mb-4">
              <img src="assets/images/hand-key.svg" width="30%" />
            </div>
            <div>
              <p class="sb-ttl resetpswdtxt semi-bold text-center">
                Your password has been successfully reset!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
